import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import {Observable} from "rxjs";
import { Annotation } from '../../models/annotation';
import { AnnotationService } from '../../services/annotation.service';

@Component({
  selector: 'app-annotation-dialog',
  templateUrl: './annotation-dialog.component.html',
  styleUrls: ['./annotation-dialog.component.css']
})
export class AnnotationDialogComponent implements OnInit {

  annotations: Observable<Annotation[]>;
  userId: string;
  jobId: string;
  noteLoading: boolean;
  noteMax: number = 1;
  notePage: number = 1;
  noteTotal: number = 0;
  newAnnotation: string;
  errorMessage: string;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    public annotation: AnnotationService,
    public dialogRef: MdDialogRef<AnnotationDialogComponent>) { }

  ngOnInit() {
    this.userId = this.data.userId;
    this.jobId = this.data.jobId;
    this.noteMax = this.data.noteMax;
    this.fetchAnnotations(1);
  }

  fetchAnnotations(page) {
    this.noteLoading = true;
    this.annotation.getAnnotation(this.userId, undefined, page, this.noteMax)
      .subscribe(
        res => {
          this.noteTotal = res.pagination.total;
          this.notePage = page;
          this.noteLoading = false;
          this.annotations = res.annotations;
        },
        error => {
          this.noteLoading = false;
        }
      )
    }

  addAnnotation() {
    this.annotation.postAnnotation(this.jobId, this.userId, this.newAnnotation).subscribe(
      data => {
        this.newAnnotation = '';
        this.fetchAnnotations(1);
      },
      error => {
        this.errorMessage = <any>error;
      }
    );
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/annotation-dialog/annotation-dialog.component.ts